<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="timeout"
    :right="$vuetify.breakpoint.smAndUp"
    :top="$vuetify.breakpoint.smAndUp"
    color="white"
  >
    <div
      :style="feedbackStyle"
      :class="[`${type}--text`, 'd-flex align-center px-2']"
    >
      <v-icon v-text="`$${type}`" class="mr-4" :color="type"/>
      <span v-text="message"/>
    </div>

    <template v-slot:action="{ attrs }">
      <div class="d-flex align-center px-2">
        <cp-icon-button
          icon="$close"
          size="small"
          :color="type"
          v-bind="attrs"
          @click="snackbar = false"
        />
      </div>
    </template>
  </v-snackbar>
</template>

<script>
import hexToRgba from 'hexToRgba';

export default {
  data: () => ({
    snackbar: false,
    timeout: 4000,
    message: '',
    type: null,
  }),
  methods: {
    show(config = {}) {
      const { 
        message = '',
        type = 'success',
      } = config;

      if (!message) throw 'required message';

      this.message = message;
      this.type = type;

      this.snackbar = false;
      this.$nextTick(() => {
        this.snackbar = true;
      });
    },
  },
  computed: {
    feedbackStyle() {
      const color = hexToRgba.call(this, this.type);

      return {
        'background-color': color,
        'min-height': '48px',
        'border-right': `2px solid ${color}`,
      };
    },
  },
}
</script>
